import {WeaTab, WeaCheckbox, WeaAlertPage} from 'ecCom';
import {Pagination, Button, Spin} from 'antd';
import {inject, observer} from "mobx-react";
import ReplyItem from '../item/';
import {toJS} from 'mobx';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@inject("coworkMainStore")
@observer
class ReplyList extends React.Component {
	constructor(props) {
		super(props);
	}
	// 移到store的chooseCowork中。
	// componentDidMount() {
   //  // const {coworkMainStore} = this.props;
   //  // coworkMainStore.reloadRecordList();
  // }
  // componentWillReceiveProps(nextProps) {
   //  // if (nextProps.coworkId != this.props.coworkId) {
   //  //   const {coworkMainStore} = this.props;
   //  //   coworkMainStore.reloadRecordList();
   //  // }
  // }
	render() {
    const {coworkMainStore, batchOperate, isCanAnonymous, canReply} = this.props;
    let {content} = coworkMainStore;
    content = toJS(content);
    let {recordList=[], replyListViewRight=0, checkIds,recordLoading} = content;
    if (replyListViewRight != 1) {
      return <WeaAlertPage style={{height: 200, position:'relative', paddingTop: "50px"}}><div>{getLabel(382663,'暂无权限')}</div></WeaAlertPage>;
    }
		return (
			<div className="wea-cowork-reply-list">
        <div>
          {recordLoading ? <div style={{height: window.innerHeight}}><div className="top40 align-center" style={{position: 'relative'}}><Spin tip={`${getLabel(31230, '加载中')}...`}/></div></div> :
            recordList && recordList.length > 0 ? recordList.map((record) => {
              let checked = checkIds.some((id) => record.id == id);
              return <ReplyItem {...record}
                                batchOperate={batchOperate}
                                operate={coworkMainStore.operateDicsuss}
                                submit={this.props.submit}
                                isCanAnonymous={isCanAnonymous}
                                check={this.check}
                                canReply={canReply}
                                checked={checked}/>;
            }) : (
              <div style={{height: window.innerHeight}}>
                <WeaAlertPage icon="icon-coms-blank" paddingTop="40px">
                  <div>{getLabel(83553, '暂无数据')}</div>
                </WeaAlertPage>
              </div>
            )
          }
        </div>
      </div>
		);
	}
  
  changePage = (current) => {
    const {coworkMainStore} = this.props;
    coworkMainStore.queryRecordList({currentPage: current}, this.props.scrollToTop);
  }
  check = (id, bool) => {
    const {coworkMainStore} = this.props;
    coworkMainStore.check(id, bool);
  }
}
export default ReplyList;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/content/ReplyList.js